module.exports = __webpack_public_path__ + "img/een-logo-white.5586efae.png";